module.exports = __webpack_public_path__ + "img/step_2.029fda1a.png";